<div
  class="nvc-width-hundred nvc-height-hundred"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <div
    class="nvc-width-hundred nvc-height-auto nvc-container"
    fxLayout="column"
    fxLayoutAlign="start start"
  >
    <div
      class="nvc-width-hundred sc-title-text"
      fxLayout="row"
      fxLayoutAlign="start start"
    >
      {{
        !this.liveshopService.videoPermissionsAllowed &&
        !this.liveshopService.audioPermissionsAllowed
          ? "Microphone and camera are blocked"
          : !this.liveshopService.audioPermissionsAllowed
          ? "Your microphone is blocked"
          : "Your camera is blocked"
      }}
    </div>
    <div class="sc-body-text">
      <span>Video call requires access to your</span>
      <span>{{
        !this.liveshopService.videoPermissionsAllowed &&
        !this.liveshopService.audioPermissionsAllowed
          ? " microphone and camera. "
          : !this.liveshopService.audioPermissionsAllowed
          ? " microphone. "
          : " camera. "
      }}</span>
      <span>Click the</span>
      <span *ngIf="!this.liveshopService.audioPermissionsAllowed">
        microphone blocked icon
        <img
          class="nvc-block-icon"
          src="assets/icons/blocked_mic.svg"
          alt="image"
        />
      </span>
      <span
        *ngIf="
          !this.liveshopService.videoPermissionsAllowed &&
          !this.liveshopService.audioPermissionsAllowed
        "
      >
        &
      </span>
      <span *ngIf="!this.liveshopService.videoPermissionsAllowed">
        camera blocked icon
        <img
          class="nvc-block-icon"
          src="assets/icons/blocked_camera.svg"
          alt="image"
        />
      </span>
      <span> in your browser permissions.</span>
    </div>
    <div
      class="nvc-width-hundred nvc-height-hundred sc-dismiss-button"
      fxLayout="row"
      fxLayoutAlign="end end"
    >
      <span class="ws-cursor-pointer" (click)="closeDialog()">Dismiss</span>
    </div>
  </div>
</div>
